<div class="col-12" *ngIf="gridload">
  <app-busy [message]="message"></app-busy>
</div>
<button style="display: none;" (click)="navigateToApplyPermit()" id="actionApplyPermit2"></button>
<button style="display: none;" (click)="navigatePermit(selectedPermitData,'edit')" id="actionEditPermit"></button>
<button style="display: none;" (click)="navigatePermit(selectedPermitData,'view')" id="actionViewPermit"></button>
<button style="display: none;" (click)="navigatePermit(selectedPermitData,'delete')" id="actionDeletePermit"></button>
<button style="display: none;" (click)="navigatePermit(selectedPermitData,'vehicle')" id="actionChangeVehicle"></button>
<button style="display: none;" (click)="navigatePermit(selectedPermitData,'duplicate')" id="actionDuplicatePermit"></button>
<button style="display: none;" (click)="navigatePermit(selectedPermitData,'renew')" id="actionRenewPermit"></button>
<button style="display: none;" (click)="navigatePermit(selectedPermitData,'permitCorrection')" id="actionCorrection"></button>
<button style="display: none;" (click)="navigatePermit(selectedPermitData,'route')" id="actionRoute"></button>
<button style="display: none;" (click)="filterPermits()" id="btnPermitSearch"></button>
<button style="display: none;" (click)="resetData()" id="btnPermitResetFilter"></button>
<!-- <button style="display: none;" (click)="navigatePermit(selectedPermitData,'delete')" id="actionDeletePermit"></button>
<button style="display: none;" (click)="navigatePermit(selectedPermitData,'delete')" id="actionDeletePermit"></button>
<button style="display: none;" (click)="navigatePermit(selectedPermitData,'delete')" id="actionDeletePermit"></button> -->


<img src="../../../../../assets/newimg/arrow-1-3@2x.png" (click)="onBack()" style="cursor: pointer;margin: 10px;" />
<strong>
  <h5>Permit Applications for {{dataCntrl.carrier.name}}</h5>
</strong>
<div class="container-fluid">
 <app-filter></app-filter>
  <app-actions *ngIf="!isViewPermitHistory" [selectedPermitData]="selectedPermitData"></app-actions>
   <br>
  <div class="row">
    <div class="col-md-12">
      <table class="table" *ngIf="appId == 0">
        <thead>
          <tr>
            <!--<th rowspan="2" style="min-width:100px !important;"></th>-->
            <th></th>
            <th rowspan="2" title="permit type description">PermitNum / Issue <i style="vertical-align:middle; "
                class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                (click)="utility.onSort(1)"></i></th>
            <th rowspan="2" title="permit type description">Permit Type <i style="vertical-align:middle; " class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                (click)="utility.onSort(2)"></i></th>
            <!--<<th rowspan="2"></th>-->
            <!--<th rowspan="2">Type<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(2)"></i></th>-->

            <th rowspan="2">Start Date <i style="vertical-align:middle; " class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                (click)="utility.onSort(3)"></i></th>
            <th rowspan="2">End Date <i style="vertical-align:middle; " class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                (click)="utility.onSort(4)"></i></th>

            <!-- <th colspan="2">Vehicle</th> -->
            <th>Vehicle Reg Number <i style="vertical-align:middle; " class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                (click)="utility.onSort(9)"></i></th>
            <th rowspan="2">Route <i style="vertical-align:middle; " class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                (click)="utility.onSort(6)"></i></th>
            <!-- <th rowspan="2">Application Date<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(7)"></i></th> -->
            <th rowspan="2">Status <i style="vertical-align:middle; " class="fa"
                [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                (click)="utility.onSort(5)"></i></th>
                <th>Actions</th>
            <!-- <th rowspan="2" valign="bottom">
                      <a [routerLink]="['/carrier/permit/application/new/'+dataCntrl.carrierID]" title="" style="width:180px; float: right;">
                        <span title="Add a New Permit Application" class=" btn-add btn btn-primary pull-right" style="width: auto;">Apply for Permit</span>
                      </a>
                    </th> -->
                    <!-- <th style="margin-left:5px;display: none;">Actions </th> -->
          </tr>
          <!-- <tr>
                    <th>Type<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(8)"></i></th>
                    <th>Registration Number<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(9)"></i></th>
                  </tr> -->

                </thead>
                <tbody>
                  <tr
                  *ngFor="let item of dataCntrl.permits | paginate: { itemsPerPage: pageSize, currentPage: pageNumber, id: 'apps', totalItems: Count }, let i=index">
                  <ng-container *ngIf="item!=null">
                    <td><input type="checkbox" value="{{item.id}}" [ngModel]="selectedIndex === item.id" (change)="CheckedPermit($event,item,item.id)"></td>
                     <!--<td title="{{item.listRes.carrier.name}}">{{item.listRes.carrier.carrier_code}}</td>-->
                  <td>
                    <a [routerLink]="['/history/permit/application/view/', item.application_id]"
                       style="color: #00008b; text-decoration: underline"
                    ><span title="View Permit"> {{item.permit_num}} /
                      {{item.permit_issue}}</span></a>
                  </td>
                    <!--<td>{{item.listRes.permit.face_value_num}}</td>-->
                     <td title="{{item.permit_type.description}}">{{item.permit_type.description}}</td>
                    <td><span *ngIf="item.date_valid_from!=null">
                      {{item.date_valid_from | date:'dd/MM/yyyy'}}</span></td>
                    <td>
                      <span *ngIf="item.date_valid_to!=null">{{item.date_valid_to | date:'dd/MM/yyyy'}}</span></td>

              <!-- <td title = "{{item.listRes.vehicle_type}}">{{item.listRes.vehicle_type_code}}</td> -->
              <td>{{item.vehicle_reg_num}}</td>
              <td title="{{item.route_summary}}">{{item.route_summary}}</td>
              <!-- <td>
                      <span *ngIf="item.listRes.submission_date!=null">
                        {{item.listRes.submission_date | date:'dd/MM/yyyy'}}
                      </span>
                    </td> -->
              <td title="{{item.status_description}}">
                <!--{{item.status_id}}->-->{{item.status_description}}
              </td>
              <!-- <td *ngIf="item.status_description === 'Approved'" class="text-center"> -->
                <td class="text-center">
                <img
                  src="../../../assets/newimg/close-6@2x.png"
                  title="Cancel Permit"
                  (click)="changeStatus(item.id , item)"
                  style="cursor: pointer; width: 18px"
                /> Cancel Permit
              </td>
              <!-- <td style="text-align: left; width: 200px !important;display: none;">
                <span  id="p" title="Edit Permit"
                style="margin: 0%" class="btn  btn-sm pull-center myButton"
                (click)="navigatePermit(item,'edit')">
                <img src="/assets/newimg/border-color-13@2x.png" class="permit-view" />
              </span>
              <span  id="p" title="View  Permit"
              style="margin: 0%" class="btn  btn-sm pull-center myButton"
              (click)="navigatePermit(item,'view')">
              <img src="/assets/newimg/visibility-2@2x.png" class="permit-view" />
            </span></td> -->
              <!-- <td>
                      <select class="form-control" (change)="navigatePermit(item,change)" id="selectControl" #change>
                        <option value="">Select</option>

                        <option class="app-option" [value]="'view'">View Permit</option>
                       <option class="app-option" [value]="'cancelApp'" *ngIf="item.application.status_id != 51 && item.application.status_id != 41 && item.application.status_id != 92">Cancel Permit</option>
                        <option class="app-option" [value]="'renew'" *ngIf="item.application.status_id >= 75 && item.application.status_id <= 80">Renew Permit</option>
                        <option class="app-option" [value]="'vehicle'" *ngIf="(item.application.status_id >= 75 && item.application.status_id <= 80) && item.is_valid">Vehicle Replacement</option>
                        <option class="app-option" [value]="'permitCorrection'" *ngIf="(item.application.status_id >= 75 && item.application.status_id <= 80) && item.application.permit_type.can_correct_error && item.is_valid">Error Correction</option>
                        <option class="app-option" [value]="'route'" *ngIf="(item.application.status_id >= 75 && item.application.status_id <= 80) && isCanBeAmended(item.application)">Route Amendment</option>
                        <option class="app-option" [value]="'duplicate'" *ngIf="(item.application.status_id >= 75 && item.application.status_id <= 80) && item.application.permit_type.can_get_duplicate">Duplicate Permit</option>
                        <option class="app-option" [value]="'edit'" *ngIf="(item.application.status_id >= 1 && item.application.status_id <= 2 )">Edit Application</option>
                        <option class="app-option" [value]="'delete'" *ngIf="(item.application.status_id >= 1 && item.application.status_id <= 11 )">Delete Application</option>



                        

                      </select>

                    </td> -->
            </ng-container>
          </tr>
        </tbody>
      </table>


      <!-- For Permit Cancel From Application -->
      <ng-container *ngIf="appId > 0">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th rowspan="2" style="min-width:100px !important;"></th>
              <th rowspan="2" title="permit type description">Permit#<i style="vertical-align:middle; " class="fa"
                  [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                  (click)="utility.onSort(1)"></i></th>
              <th rowspan="2"></th>
              <th rowspan="2">Type<i style="vertical-align:middle; " class="fa"
                  [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                  (click)="utility.onSort(2)"></i></th>
              <th rowspan="2">Start<i style="vertical-align:middle; " class="fa"
                  [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                  (click)="utility.onSort(3)"></i></th>
              <th rowspan="2">End<i style="vertical-align:middle; " class="fa"
                  [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                  (click)="utility.onSort(4)"></i></th>
              <th rowspan="2">Status<i style="vertical-align:middle; " class="fa"
                  [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                  (click)="utility.onSort(5)"></i></th>
              <th colspan="2">Vehicle</th>
              <th rowspan="2">Route<i style="vertical-align:middle; " class="fa"
                  [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                  (click)="utility.onSort(6)"></i></th>
              <!-- <th rowspan="2">Application Date<i style="vertical-align:middle; " class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }" (click)="utility.onSort(7)"></i></th> -->
              <th rowspan="2" valign="bottom">
                <a [routerLink]="['/carrier/permit/application/new/'+dataCntrl.carrierID]" title=""
                  style="width:180px; float: right;">
                  <span title="Add a New Permit Application" class="btn-add btn btn-primary active"></span>Add
                </a>
              </th>
            </tr>
            <tr>
              <th>Type<i style="vertical-align:middle; " class="fa"
                  [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                  (click)="utility.onSort(8)"></i></th>
              <th>Registration<i style="vertical-align:middle; " class="fa"
                  [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                  (click)="utility.onSort(9)"></i></th>
            </tr>

          </thead>
          <tbody>
            <tr
              *ngFor="let p of permitObj.permits  | paginate: { itemsPerPage: pageSize, currentPage: pageNumber, id: 'apps', totalItems: Count }, let i=index">
              <ng-container *ngFor="let a of this.dataCntrl.applications">
                <td>{{a.listRes.carrier.carrier_code}}</td>
              </ng-container>
              <td>{{p.permit_num}} /
                {{p.permit_issue}}
              </td>
              <td> <span *ngIf="p.face_value_num!=null">{{p.face_value_num}}</span></td>
              <ng-container *ngFor="let a of this.dataCntrl.applications">
                <td>{{a.listRes.permit_type.code}}</td>
              </ng-container>
              <td><span *ngIf="p.date_valid_from!=null">
                  {{p.date_valid_from | date:'dd/MM/yyyy'}}</span></td>
              <td>
                <span *ngIf="p.date_valid_to!=null">{{p.date_valid_to | date:'dd/MM/yyyy'}}</span>
              </td>
              <td><span *ngIf="p.status_id!=null">{{p.status_id}}-{{p.status_description}}</span></td>
              <ng-container *ngFor="let item of this.dataCntrl.applications">
                <td title="{{item.listRes.vehicle_type}}">{{item.listRes.vehicle_type_code}}</td>
                <td>{{item.listRes.registration_number}}</td>
              </ng-container>

              <ng-container *ngFor="let a of this.dataCntrl.applications">
                <td title="{{a.listRes.route_summary}}"><span *ngIf="a.route_code!=null">{{a.route_code}}</span></td>
                <!-- <td>
                      <span *ngIf="a.listRes.submission_date!=null">
                        {{a.listRes.submission_date | date:'dd/MM/yyyy'}}
                      </span>
                    </td> -->
              </ng-container>
              <td>
                <select class="form-control" (change)="cancelApplication(p.id)" id="selectControl" #change>
                  <option value="">Select</option>
                  <option class="app-option" value="cancelApp">Cancel Application</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>




      <p class="use-mouse" *ngIf="dataCntrl.applications.length > 0">Click on the Underlined link to view account
        information</p>
      <div style="text-align:center" *ngIf="Count > 5">
        <table border="0" cellpadding="0" cellspacing="0" style="float: right;">
          <tr>
            <td style="white-space:nowrap;font-weight:bold;padding-right:3px">
              Show :
            </td>
            <td style="white-space: nowrap">
              <select style="cursor:pointer" [(ngModel)]="pageSize" (ngModelChange)="pageSizeChange()">
                <option *ngFor="let size of pageSizes()" [ngValue]="size"> {{pageSizeName(size)}} </option>
              </select>
            </td>
          </tr>
        </table>
        <pagination-controls class="my-pagination" (pageChange)="pageNumber = onPage($event)" id="apps">
        </pagination-controls>
      </div>
      <div>
        <tfoot>
          <tr *ngIf="isEmpty">
            <td colspan="9" class="rm-brd">
              <span class="text-info text-small; color:black">No permits found.</span>
            </td>
          </tr>

        </tfoot>

      </div>
      <!-- <div style="text-align:center" *ngIf="dataCntrl.applications.length <= 0 && loadCompleted">
                <h5>No Permits Found</h5>
              </div>-->
    </div>
  </div>
  <div>
    <!-- <div class="card-data">
            <div class="col-md-12">
                <button title="Back" type="button" id="btnBack" (click)="onBack()" class="btn btn-md btn-primary pull-right" style="margin-left:10px; ">Back</button>
              </div>
        </div> -->
  </div>
</div>



<div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Printed Permit</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-lg">

        <pdf-viewer *ngIf="pdfSrc" [src]="pdfSrc" [render-text]="true" style="display: block;" [original-size]="false"
          [autoresize]="true"></pdf-viewer>

        <ngx-loading [show]="isLoadingImg"></ngx-loading>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" data-dismiss="modal">Close</button>
        <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
      </div>
    </div>
  </div>
</div>
